import { render, staticRenderFns } from "./Message-Dialog.vue?vue&type=template&id=6a4d36cc"
import script from "./Message-Dialog.vue?vue&type=script&lang=js"
export * from "./Message-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports